<div
  class="w-100 h-100"
  *ngIf="activityData?.api "
>
  <mng-resources-manager-list-items-webcomponent
    [procedureId]="activityData?.metadata?.procedure_id"
    [reportId]="activityData?.metadata?.process_id"
    [url]="activityData?.api"
    [isEdit]="activityData?.costManagerEdit"
    [metadata]="activityData?.metadata?.metadata"
    (emitDataProcedure)="onSaveData($event)"
  ></mng-resources-manager-list-items-webcomponent>

</div>
